var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cw-header",style:(_vm.safeAreaInsetStyle)},[_c('div',{staticClass:"fixed-container navbar is-mobile"},[_c('div',{staticClass:"navbar-left"},[_vm._t("left-items")],2),_c('div',{staticClass:"navbar-center has-text-centered"},[_vm._t("content")],2),_c('div',{staticClass:"navbar-right"},[_vm._t("right-items")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }